import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type CallbackLeadRecord = NonNullable<
  ResultOf<typeof callbackLeadRecordQuery>["callbackLead"]
>;

export type CallbackLeadRecordBooking = CallbackLeadRecord["bookings"][number];

export const callbackLeadRecordQuery = graphql(`
  query CallbackLeadRecord($id: ID!) {
    callbackLead(id: $id) {
      id
      status
      source
      outcome
      note
      name
      email
      phone
      contact_attempts
      last_contacted_at
      snoozed_until
      expires_at
      created_at
      bookings_count
      booking {
        id
        reference
        name
        status
        currency
        created_at
        depart_at
        deliver_at
        date_of_birth
        number_of_travellers
        distance_allowed
        hire_unit_type
        measurement
        customer_note
        customer_url
        charge_summary {
          pay_now_total_amount
          pay_later_total_amount
          total_amount
        }
        departureOffice {
          id
          name
        }
        deliveryOffice {
          id
          name
        }
        vehicle {
          id
          name
          type
          transmission
          seatbelts
        }
        supplier {
          id
          name
        }
        inclusions {
          id
          type
          description
          value
          has_free_tank
        }
        relocation {
          id
          reference
          customer_url
          status
          count
          available_from_date
          available_to_date
          hire_units_allowed
          extra_hire_units_allowed
          extra_hire_unit_rate
        }
      }
      bookings {
        id
        reference
        status
        created_at
        depart_at
        currency
        charge_summary {
          total_amount
        }
        departureOffice {
          id
          name
        }
        deliveryOffice {
          id
          name
        }
      }
    }
  }
`);
